<template>
    <div class="vx-row">
        <template v-for="chart in charts">
            <component :is="chart.type" :data="chart.data" :key="chart.id"></component>
        </template>
    </div>
</template>

<script>
    import CardLine from "./CardLine";
    import RadialBar from "./RadialBar";
    import ComparisonLine from "./ComparisonLine";
    import RadialChart from "./RadialChart";
    import CardLists from "./CardLists";

    export default {
        props: ['charts'],
        components: {
            CardLine,
            RadialBar,
            ComparisonLine,
            RadialChart,
            CardLists
        }
    }

</script>